import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { testimonials, accents } from '../../data/site';
function initials(name: string) {
  return name.split(' ').filter(part => part.length > 1).slice(0, 2).map(part => part[0]).join('');
}
export function Testimonials() {
  return <section className="bg-white py-24 lg:py-32" data-id="element-233" data-mp="3ffv4oebqwtrt">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-234" data-mp="3ahjvm5t9ynan">
        <SectionHeading eyebrow="Executive Recommendations" title="What CEOs, directors, and peers say." data-id="element-235" data-mp="3ai3cdj76v5n3" />

        <div className="mt-16 grid gap-6 lg:grid-cols-2" data-id="element-236" data-mp="31glxg45ip9zz">
          {testimonials.map((item, index) => <Reveal key={item.name} delay={index % 2 * 0.08} data-id="element-237" data-mp="1u2s9gamq2c9s" data-mpi={index}>
              <motion.figure whileHover={{
            y: -4
          }} transition={{
            duration: 0.4,
            ease: [0.22, 1, 0.36, 1]
          }} className="group relative h-full overflow-hidden rounded-xl border border-navy/10 bg-mist p-8 transition-shadow duration-500 hover:shadow-lux" data-id="element-238" data-mp="1u0xrn56qz09x">
                <QuoteIcon className="absolute right-7 top-7 h-7 w-7 text-navy/10 transition-colors duration-500 group-hover:text-gold/40" aria-hidden="true" data-id="element-239" data-mp="2q9tbsbzvhckq" />
                <blockquote className="relative text-[0.975rem] leading-[1.8] text-charcoal/80" data-id="element-240" data-mp="2gk9pewcyb0l4">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-4 border-t border-navy/10 pt-6" data-id="element-241" data-mp="2lc17eii1jxzn">
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full text-xs font-medium tracking-wide text-white" style={{
                backgroundColor: accents[index % accents.length]
              }} data-id="element-242" data-mp="26nn64c09whl7">
                    {initials(item.name)}
                  </span>
                  <span data-id="element-243" data-mp="83qhelihiksg">
                    <span className="block text-sm font-medium text-navy" data-id="element-244" data-mp="849yk00b955f">{item.name}</span>
                    <span className="block text-xs text-charcoal/60" data-id="element-245" data-mp="3d1qp8emprud">{item.title}</span>
                    <span className="mt-1 block text-[0.7rem] uppercase tracking-[0.15em] text-royal" data-id="element-246" data-mp="3ujbgzfi6w2ud">
                      {item.relationship}
                    </span>
                  </span>
                </figcaption>
              </motion.figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}